import React, { Component } from 'react';
import Navbar from './Navbar';
import { Link } from 'react-router-dom';
import logo from '../assets/images/logo.svg';

class Header extends Component {
    
    render() {
        return (
        <header className='b-light header z-5 c-100 border-wrapper'>
            <div className='border-card-item'>
                <ul className='p-lr-3 m-c sm-lr-0'>
                    <li className='d-i-b c-30 v-a-m sm-c-70 t-a-l'>
                        <Link className='d-i-b' to='/'>
                            <img className='v-a-m logo' src={logo} />
                        </Link>
                    </li>

                    <li className='d-i-b c-70 v-a-m sm-c-30'>
                        <Navbar/>
                    </li>
                </ul>
            </div>
        </header>
        );
    }
}

export default Header;
